module.exports = __webpack_public_path__ + "static/img/Wallpaper.e1a9ce6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/funplus/imgs/browse/Wallpaper.jpg
// module id = 1954
// module chunks = 0